import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonAsync } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	fullWidth?: boolean
	link?: boolean
	slim?: boolean
	type?: keyof Omit<typeof helpers.color, 'status' | 'input' | 'button'>
}

export const Link = styled(ButtonAsync)<Props>`
	color: ${({ type = 'primary', theme }) => theme.color[type]};
	background-color: ${({ type = 'primary', link, theme }) => !link && transparentize(0.9, theme.color[type])};
	font-family: ${helpers.font.family.header};

	width: ${({ fullWidth }) => fullWidth && '100%'};
	min-width: ${({ slim }) => (slim ? 40 : 120)}px;
	font-size: ${({ slim, theme }) => (slim ? theme.font.size.small : theme.font.size.base)};
	height: ${({ slim, link }) => (link ? 'unset' : slim ? '30px' : '36px')};
	padding-left: ${({ slim }) => (slim ? 10 : 16)}px;
	padding-right: ${({ slim }) => (slim ? 10 : 16)}px;
	border-radius: 12px;
	transition: color 0.2s, background-color 0.2s;
	margin: ${({ link }) => link && '0'};
	isolation: isolate;

	&:is(:focus-visible, :hover) {
		background-color: ${({ type = 'primary', link, theme }) => !link && transparentize(0.8, theme.color[type])};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:after {
		content: '';
		display: block;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		pointer-events: none;
		background-image: radial-gradient(circle, ${({ type = 'primary', theme }) => theme.color[type]} 16%, transparent 16.01%);
		background-repeat: no-repeat;
		background-position: 50%;
		transform: scale(10, 10);
		opacity: 0;
		transition: transform 0.7s, opacity 0.9s;
	}

	&:active:after {
		transform: scale(0, 0);
		opacity: 0.2;
		transition: 0s;
	}

	&:disabled:after {
		opacity: 0;
	}

	&:disabled {
		color: ${helpers.color.disabled};
		background-color: transparent;
	}
`
